import { render, staticRenderFns } from "./SolicitudStockPantalla.vue?vue&type=template&id=502cc868&"
import script from "./SolicitudStockPantalla.vue?vue&type=script&lang=ts&"
export * from "./SolicitudStockPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('502cc868', component.options)
    } else {
      api.reload('502cc868', component.options)
    }
    module.hot.accept("./SolicitudStockPantalla.vue?vue&type=template&id=502cc868&", function () {
      api.rerender('502cc868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudStock/SolicitudStockPantalla.vue"
export default component.exports